export default __webpack_public_path__ + "static/media/icon-notification-gray.d3f5dfbc.svg";